import styled, { css } from "styled-components";

const SideNavStyled = styled.div`
    background-color: ${props => props.theme.heritageGreen};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    height: 100vh;
    width: 100%;
    flex-shrink: 0;
    white-space: nowrap;
    overflow-y: auto;

    ${props =>
        props.business &&
        css`
            background-color: ${props.theme.teal};
        `}

    ul {
        li {
            &.hidden {
                display: none;
            }

            &:before {
                display: none;
            }
        }
    }

    .sidenav-menu-item {
        font-family: ${props => props.theme.fontBold};
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        padding: 1rem 0;
        color: ${props => props.theme.white};
        text-decoration: none;

        p {
            opacity: 0.8;
            font-size: 1.9rem;
            line-height: 2.4rem;
            font-weight: 700;
        }

        &:hover {
            color: ${props => props.theme.limeGreen};

            p {
                opacity: 1;
            }

            ${props =>
                props.business &&
                css`
                    color: ${props.theme.iceBlue};
                `}

            &:before {
                content: "";
                position: absolute;
                left: -3.2rem;

                ${props =>
                    props.collapsed &&
                    css`
                        left: -4rem;
                    `}

                top: 0;
                background-color: ${props => props.theme.limeGreen};

                ${props =>
                    props.business &&
                    css`
                        background-color: ${props.theme.iceBlue};
                    `}

                width: 0.8rem;
                height: 5.2rem;
                border-radius: 0 2rem 2rem 0;
            }
        }

        &.active-link {
            color: ${props => props.theme.limeGreen};

            p {
                opacity: 1;
            }

            ${props =>
                props.business &&
                css`
                    color: ${props.theme.iceBlue};
                `}

            &:before {
                content: "";
                position: absolute;
                left: -3.2rem;
                top: 0;
                background-color: ${props => props.theme.limeGreen};

                ${props =>
                    props.business &&
                    css`
                        background-color: ${props.theme.iceBlue};
                    `}

                width: 0.8rem;
                height: 5.2rem;
                border-radius: 0 2rem 2rem 0;
            }
        }

        span {
            display: flex;
            margin-right: 1.6rem;

            ${props =>
                props.collapsed &&
                css`
                    margin-right: 0;
                `}

            img {
                &.sidenav__icon {
                }
            }
        }
    }

    .sideNav__links {
        padding: 3.2rem;
        width: 100%;

        ${props =>
            props.collapsed &&
            css`
                width: 100%;
            `}

        li {
            margin-block: 1.6rem;
        }
    }

    .collapse {
        &__section {
            position: relative;
            padding: 3.2rem;
            width: 100%;
            height: 100%;
        }

        &__button {
            font-family: ${props => props.theme.fontBold};
            font-size: 1.8rem;
            position: absolute;
            bottom: 8rem;
            line-height: 2.4rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            color: ${props => props.theme.white};

            svg {
                margin-right: 1.6rem;
                transition: 0.3s all ease-in-out;
                ${props =>
                    props.collapsed &&
                    css`
                        margin-right: 0;
                        transform: rotate(180deg);
                    `}
            }

            &:hover {
                color: ${props => props.theme.limeGreen};
                    ${props =>
                        props.business &&
                        css`
                            color: ${props.theme.iceBlue};
                        `};
            }
        }
    }

    .switch__profile {
        font-family: ${props => props.theme.fontBold};
        font-size: 1.8rem;
        line-height: 2.4rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        color: ${props => props.theme.white};

        svg {
            margin-right: 1.6rem;
            ${props =>
                props.collapsed &&
                css`
                    margin: 0 auto;
                `}
        }

        &:hover {
            color: ${props => props.theme.limeGreen};
                ${props =>
                    props.business &&
                    css`
                        color: ${props.theme.iceBlue};
                    `};
        }
    }
`;

const LineSeparator = styled.div`
    position: relative;
    left: 0;
    background-color: ${props => props.theme.mintGreen};
    height: 0.2rem;
    width: 100%;
    border-radius: 1rem;
    transform: translateX(0) scaleX(1);
    transition: all 0.3s ease-in-out;

    ${props =>
        props.business && css`
            background-color: ${props.theme.atlanticBlue};
        `}

    ${props =>
        props.collapsed && css`
            left: -0.8rem;
            width: calc(100% + 2rem);
    `}
`;

export { SideNavStyled, LineSeparator };
